import * as React from 'react';
import {
    BooleanInput,
    Create,
    Edit,
    EditButton,
    FunctionField,
    List,
    required,
    SimpleForm,
    TextField,
    TextInput,
} from 'react-admin';
import AdminPagination from '../AdminPagination';
import AdminSelectableDatagrid from '../AdminSelectableDatagrid';
import { ResourceListTitle } from '../AdminResourceTotalCount';
import HumanDeleteButton from '../HumanDeleteButton';
import HumanRecordTitle from '../HumanRecordTitle';
import { ContentCatalogMembershipInputs } from '../ContentCatalogMembershipInputs';

const filters = [
    <TextInput
        source="all"
        label="Rechercher"
        alwaysOn
    />
];

export const IntroVideoList = (props: any) => {
    const demoMode = Boolean(props.demoMode);

    return (
        <List
            title={
                <ResourceListTitle
                    resource="introvideo"
                    label={
                        demoMode
                            ? "Vidéos introduction — Démo"
                            : "Vidéos introduction"
                    }
                    queryString={`is_demo=${demoMode}`}
                />
            }
            {...props}
            filter={{ is_demo: demoMode }}
            filters={filters}
            bulkActionButtons={false}
            sort={{ field: 'name', order: 'ASC' }}
            perPage={50}
            pagination={<AdminPagination />}
            exporter={false}
        >
            <AdminSelectableDatagrid>
                <TextField
                    source="name"
                    label="Nom"
                />

                <TextField
                    source="video"
                    label="ID vidéo"
                />

                <FunctionField
                    label="Standard"
                    render={(record: any) =>
                        record?.is_standard
                            ? 'Oui'
                            : 'Non'
                    }
                />

                <EditButton />

                <HumanDeleteButton
                    fields={["name"]}
                    fallback="cette vidéo introduction"
                />
            </AdminSelectableDatagrid>
        </List>
    );
};

export const IntroVideoEdit = (props: any) => (
    <Edit
        {...props}
        mutationMode="pessimistic"
        title={
            <HumanRecordTitle
                fields={["name"]}
                fallback="Vidéo introduction"
            />
        }
    >
        <SimpleForm redirect={props.basePath || 'list'}>
            <TextInput
                source="name"
                label="Nom"
                validate={required()}
            />

            <TextInput
                source="video"
                label="ID vidéo VdoCipher"
                validate={required()}
            />

            <BooleanInput
                source="is_demo"
                label="Démo"
                defaultValue={Boolean(props.demoMode)}
            />

            <ContentCatalogMembershipInputs
                defaultStandard={false}
            />
        </SimpleForm>
    </Edit>
);

export const IntroVideoCreate = (props: any) => (
    <Create {...props}>
        <SimpleForm redirect={props.basePath || 'list'}>
            <TextInput
                source="name"
                label="Nom"
                validate={required()}
            />

            <TextInput
                source="video"
                label="ID vidéo VdoCipher"
                validate={required()}
            />

            <BooleanInput
                source="is_demo"
                label="Démo"
                defaultValue={Boolean(props.demoMode)}
            />

            <ContentCatalogMembershipInputs
                defaultStandard={false}
            />
        </SimpleForm>
    </Create>
);
